import classNames from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';
import QRCode from 'react-qr-code';

import countryCodeToReadable from 'utils/country-code-to-readable';

import cardBackMOE from './Back-MOE.png';
import cardBackTSC from './Back-TSC.png';
import cardBack from './Back.png';
import cardFrontMOE from './Front-MOE.png';
import cardFrontTSC from './Front-TSC.png';
import cardFront from './Front.png';
import cardHiddenBack from './Hidden-Back.png';
import cardHiddenFront from './Hidden-Front.png';
import secretarySignature from './secretary-signature.png';
import theme from './theme.module.scss';

type IdentityCard = {
  id: string;
  cardNumber: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    gender: string;
    department: {
      id: string;
      name: string;
    };
    nationality: string;
  };
  employee: {
    id: string;
    organisationCode: 'DOE' | 'TSC' | 'OLA' | 'MOE';
    fileNumber: string;
    division: {
      id: string;
      name: string;
    };
    designation: {
      id: string;
      name: string;
    };
    signature?: string;
    photo: string;
  };
  codeLink: string;
  issueDate: string;
  expiryDate: string;
};

const MOEIdentityCard: FC<{
  identityCard: IdentityCard;
  visibileOnly?: boolean;
}> = ({ identityCard, visibileOnly = false }) => {
  const { label: countryLabel } = countryCodeToReadable(identityCard.user.nationality);

  const cardImage = {
    front:
      identityCard.employee.organisationCode === 'TSC'
        ? cardFrontTSC
        : identityCard.employee.organisationCode === 'MOE'
        ? cardFrontMOE
        : cardFront,
    hiddenFront: cardHiddenFront,
    back:
      identityCard.employee.organisationCode === 'TSC'
        ? cardBackTSC
        : identityCard.employee.organisationCode === 'MOE'
        ? cardBackMOE
        : cardBack,
    hiddenBack: cardHiddenBack,
  };

  return (
    <div className={theme.container}>
      <div className={theme.page}>
        <img className={theme.background} src={cardImage.front} alt="Card Front" />
        <span className={theme.heading}>PAPUA NEW GUINEA</span>
        <span className={theme.subHeading}>
          {identityCard.employee.organisationCode === 'MOE' ? 'MINISTRY' : 'DEPARTMENT'} OF
          EDUCATION
        </span>
        <img className={theme.photo} src={identityCard.employee.photo} alt="Employee" />
        <div className={theme.information}>
          <div className={theme.row}>
            <p className={theme.label}>First Name:</p>
            <p className={theme.value}>{identityCard.user.firstName}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Last Name:</p>
            <p className={theme.value}>{identityCard.user.lastName}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>File No:</p>
            <p className={theme.value}>{identityCard.employee.fileNumber}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Gender:</p>
            <p className={theme.value}>{identityCard.user.gender}</p>
          </div>
          {/* <div className={theme.row}>
            <p className={theme.label}>Division:</p>
            <p className={theme.value}>{identityCard.employee.division}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Designation:</p>
            <p className={theme.value}>{identityCard.employee.designation}</p>
          </div> */}
          {/* {identityCard.employee.organisationCode !== 'DOE' && (
            <div className={theme.row}>
              <p className={theme.label}>Organisation:</p>
              <p className={theme.value}>{identityCard.employee.organisationCode}</p>
            </div>
          )} */}
        </div>
        <div className={theme.signaturesContainer}>
          <div className={theme.signature}>
            {/* {identityCard.employee.organisationCode === 'DOE' ? ( */}
            <span className={theme.automatedSignature}>
              {identityCard.user.firstName.toLowerCase()} {identityCard.user.lastName.toLowerCase()}
            </span>
            {/* ) : (
              <img
                src={identityCard.employee.signature}
                alt="Employee Signature"
                className={theme.signatureImage}
              />
            )} */}
            <p className={theme.label}>Signature of Holder</p>
          </div>
          <div className={theme.signature}>
            <img
              src={secretarySignature}
              alt="Secretary Signature"
              className={theme.signatureImage}
            />
            <p className={theme.label}>Signature of Education Secretary</p>
          </div>
        </div>
      </div>
      <div className={theme.page} style={{ display: visibileOnly ? 'none' : 'block' }}>
        <img className={theme.background} src={cardImage.hiddenFront} alt="Card Hidden Front" />
      </div>
      <div className={classNames(theme.page, theme.back)}>
        <img className={theme.background} src={cardImage.back} alt="Card Back" />
        <img className={theme.photo} src={identityCard.employee.photo} alt="Employee" />
        <div className={theme.qrCodeContainer}>
          <QRCode value={identityCard.codeLink} size={525} />
        </div>
        <span className={theme.smartCardLabel}>
          {identityCard.employee.organisationCode === 'TSC'
            ? 'SMART TEACHERS ID CARD'
            : 'SMART PUBLIC SERVANTS ID CARD'}
        </span>
        <div className={theme.information}>
          <div className={theme.row}>
            <p className={theme.label}>Nationality:</p>
            <p className={theme.value}>{countryLabel}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Card No:</p>
            <p className={theme.value}>{identityCard.cardNumber}</p>
          </div>
          <div className={theme.columns}>
            <div className={theme.row}>
              <p className={theme.label}>Issue Date:</p>
              <p className={theme.value}>{dayjs(identityCard.issueDate).format('DD MMMM YYYY')}</p>
            </div>
            <div className={theme.row}>
              <p className={theme.label}>Expiry Date:</p>
              <p className={theme.value}>{dayjs(identityCard.expiryDate).format('DD MMMM YYYY')}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className={classNames(theme.page, theme.hidden)}
        style={{ display: visibileOnly ? 'none' : 'block' }}
      >
        <img className={theme.background} src={cardImage.hiddenBack} alt="Card Hidden Back" />
        <img className={theme.photo} src={identityCard.employee.photo} alt="Employee" />
      </div>
    </div>
  );
};

export default MOEIdentityCard;
